<template>
    <div class="places__list">
        <div class="places__loading" v-if="processing">
            Načítám data
        </div>
        <div class="places__emtpy" v-if="false === processing && 0 === contacts.length">
            <strong>Vašemu zadání neodpovídají žádné kontakty</strong>
        </div>
        <locator-contact v-bind="$props" :key="contact.id" :contact="contact" v-for="contact in contacts"
                         v-if="contacts.length"/>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';
    import LocatorContact from './Contact';

    export default {
        name: 'LocatorContactList',
        components: {
            LocatorContact
        },
        props: {
            onSelect: {
                type: Function | null,
                default: null,
            },
            selectedContactId: {
                type: String | Number | null,
                default: null,
            }
        },
        data() {
            return {
                error: false,
            }
        },
        computed: {
            ...mapGetters('locator', ['contacts']),
            ...mapState('locator', {
                processing: state => state.data.processing,
            }),
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/ContactList.vue